// src/components/school/AddSchoolLayer.jsx

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  addSchool,
  updateSchool,
  getSchoolById,
} from "../../services/schoolService";
import { getPackages } from "../../services/manageSchoolPackageService";
import "./AddSchoolLayer.css";

const AddSchoolLayer = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [packages, setPackages] = useState([]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    address: "",
    phone: "",
    package_id: "",
    reference_by: "",
    status: "active",
    logo: null,
  });

  const [preview, setPreview] = useState("");

  useEffect(() => {
    loadPackages();

    if (isEdit) {
      loadSchool();
    }
  }, [id]);

  const loadPackages = async () => {
    try {
      const res = await getPackages();

      if (res?.data?.status) {
        setPackages(res.data.data || []);
      } else if (res?.status) {
        setPackages(res.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadSchool = async () => {
    try {
      const res = await getSchoolById(id);

      if (res?.status === true && res.data) {
        const school = res.data;

        setForm({
          name: school.name || "",
          email: school.email || "",
          password: school.plain_password || "",
          address: school.address || "",
          phone: school.phone || "",
          package_id: school.package_id || "",
          reference_by: school.reference_by || "",
          status: school.status || "active",
          logo: null,
        });

        setPreview(school.logo_url || "");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "logo") {
      const file = files?.[0];

      setForm((prev) => ({
        ...prev,
        logo: file,
      }));

      if (file) {
        setPreview(URL.createObjectURL(file));
      }
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const res = isEdit
      ? await updateSchool(id, form)
      : await addSchool(form);

    if (res?.status === true) {
      toast.success(
        isEdit
          ? "School updated successfully"
          : "School added successfully"
      );

      navigate("/school-list");
    } else {
      toast.error(res?.message || "Something went wrong");
    }
  };

  return (
    <div className="add-school-wrapper">
      <div className="add-school-card">
        <h5>
          {isEdit ? "Update School" : "Create School"}
        </h5>

        <form onSubmit={handleSubmit}>
          <div className="grid">

            <div className="form-group">
              <label>School Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter School Name"
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter Email"
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="text"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter Password"
                required={!isEdit}
              />
            </div>

            <div className="form-group">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Enter Phone"
                required
              />
            </div>

            <div className="form-group">
              <label>Package</label>

              <select
                name="package_id"
                value={form.package_id}
                onChange={handleChange}
                required
              >
                <option value="">
                  Select Package
                </option>

                {packages.map((pkg) => (
                  <option
                    key={pkg.id}
                    value={pkg.id}
                  >
                    {pkg.package_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Reference By</label>
              <input
                type="text"
                name="reference_by"
                value={form.reference_by}
                onChange={handleChange}
                placeholder="Enter Reference By"
              />
            </div>

            <div className="form-group">
              <label>Address</label>
              <textarea
                name="address"
                value={form.address}
                onChange={handleChange}
                placeholder="Enter Address"
              />
            </div>

            <div className="form-group">
              <label>Status</label>

              <select
                name="status"
                value={form.status}
                onChange={handleChange}
              >
                <option value="active">
                  Active
                </option>

                <option value="inactive">
                  Inactive
                </option>
              </select>
            </div>

            <div className="form-group">
              <label>School Logo</label>

              <input
                type="file"
                name="logo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

            {preview && (
              <div className="form-group">
                <label>Preview</label>

                <img
                  src={preview}
                  alt="logo"
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                  }}
                />
              </div>
            )}

          </div>

          <button
            type="submit"
            className="btn-primary"
          >
            {isEdit
              ? "Update School"
              : "Add School"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddSchoolLayer;